import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import Utils from "../../utilities/Utils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { getRootComponent } from "../../utilities/ElementUtils";
interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {

}
export class DateTimeComponent extends React.Component<Props, State> {
   
  
    constructor(props: Props) {
        super(props);
        let field = this.props.field;
        FormValidationUtils.runJavascript(field);
    }
    onDateChangeOnDialog = (e) => {
        let prev = this.props.field.Value;
        const val = e.target.value
        this.props.field.Value = val;
       
        if (!FormValidationUtils.isDateTime(val)) {
            this.props.field.ErrorMessage = "Date is invalid";
            this.props.field.Valid = false;
            this.props.field.Touched=true;
          } else {
            this.props.field.Valid = true;
          }

        let subSection: FormSubSections = this.props.field.parent as FormSubSections;
    
        this.props.callbackElement(getRootComponent(this.props.field));


        let listCompareFiled = subSection.ListOfFormSectionElements.filter(ele => ele.LoadBindName == this.props.field.ValidateCompareField);
          if(listCompareFiled!=null && listCompareFiled.length>0){
            const comparedTo = listCompareFiled[0];
            if(this.props.field.ValidateCompareMethod==">") {
                if(this.props.field.Value<=comparedTo.Value){
                    this.props.field.ErrorMessage = comparedTo.ENUTitle + " must be earlier than " + this.props.field.ENUTitle;
                    this.props.field.Valid = false;
                    this.props.field.Touched=true;
                }
            }
          }


        let listScriptTriggering = subSection.ListOfFormSectionElements.filter(ele => ele.ScriptTriggerField == this.props.field.LoadBindName);
       
        if (listScriptTriggering.length > 0) {
          listScriptTriggering.forEach(ele => {
            if (ele.Script && prev != Utils.getFormattedDate(val) || ele.Value) {
              eval(ele.Script);
              this.props.callbackElement(getRootComponent(this.props.field));
            }
          })
        }

     }

    
    render() {
        let validateCpmpareField;
        let dateValid: boolean = true;    
        let field =  this.props.field;
        if(!field.Visible) return null;
        
        let displayfield: boolean = true;
        let  editable = this.props.editable;
        let labelControlArray =this.props.labelControlArray;
        let requiredField =this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;

        if (this.props.field.FilterField != null) {
            let filterValue;
            let baseName;
            let bindName;
            let parts = this.props.field.FilterField.split('.');
            if (parts.length == 3) {
                baseName = parts[0] + '.' + parts[1];
                bindName = parts[2];
            }
            if (parts.length == 2) {
                baseName = parts[0];
                bindName = parts[1];
            }
            if (parts.length == 1) {
                baseName = '';
                bindName = parts[0];
            }

            let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);

            let foundFilterField;

            if (foundFilterFields && foundFilterFields.length > 0) {
                foundFilterField = foundFilterFields[0];
            }

            if (foundFilterField != null) {
                filterValue = foundFilterField.Value;

                if (filterValue == null || filterValue != null && this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1) {
                    displayfield = false;
                }
            }
        }

        if (field.ValidateCompareMethod != null) {
            let subSection = this.props.field.parent as FormSubSections;
            let foundValidateCpmpareFieldList = subSection.ListOfFormSectionElements?.filter(p => p.LoadBindName == field.ValidateCompareField);
            if (foundValidateCpmpareFieldList!=null && foundValidateCpmpareFieldList.length > 0) {
                validateCpmpareField = foundValidateCpmpareFieldList[0];
                if (field.ValidateCompareMethod == "<")
                    dateValid = field.Value <= validateCpmpareField.Value;
                else if (field.ValidateCompareMethod == ">") {
                    dateValid = field.Value >= validateCpmpareField.Value;
                } else {
                    dateValid = field.Value == validateCpmpareField.Value;
                }
            }
        }

        if (editable) {
            controlArray.push(
                <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
                    <label htmlFor={field.LoadBindName} className="ontario-label">{labelControlArray}</label>
                    <div>
                    <LiveValidationErrMsg
                             field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" +this.props.field.LoadBindName} />

              </div>
                    <input
                        type="datetime-local"
                        id={field.LoadBindName} 
                        key={field.Id}
                        name="datetime"
                        className={this.props.field.Valid ?'ontario-input':'ontario-input ontario-input__error'}
                        value={field.Value==null?"":field.Value}
                        readOnly={field.ReadOnly}
                        onChange={(e) => this.onDateChangeOnDialog(e)}
                    />
                </div>
            )
        } else {
            const specificDate = new Date(field.Value);
            if (specificDate) {
                const year = specificDate.getFullYear();
                const month = specificDate.getMonth(); // Note: Months are 0-indexed, so January is 0, February is 1, and so on.
                const day = specificDate.getDate();
                const hours = specificDate.getHours();
                const minutes = specificDate.getMinutes();
                const seconds = specificDate.getSeconds();
                controlArray.push(
                    <div className='pdf-two-column'>
                        <div>{title}</div>
                        <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
                            {`${year}-${month + 1}-${day} ${hours}:${minutes}:${seconds}`}
                        </div>
                    </div>
                );
            }
        }

        return controlArray;
    }

}